
















import Vue from "vue";

export default Vue.extend({
  name: "OverlayPictureViewer",
  props: {
    imgUrl: String,
  },
  data() {
    return {};
  },
  methods: {
    closeOverlayPictureViewer: function () {
      this.$emit("closeOverlayPictureViewer");
    },
  },
});
